module.exports = {
    baseUrl:'/saas'
}